export const firebaseConfig = {
    apiKey: "AIzaSyAepkDF4slCiz4NH8qtdNLnK5asPn5ibM4",
    authDomain: "wine-australia-career-selector.firebaseapp.com",
    projectId: "wine-australia-career-selector",
    storageBucket: "wine-australia-career-selector.appspot.com",
    messagingSenderId: "983408031296",
    appId: "1:983408031296:web:b83346d03332da008f51a5",
};
